import RepositoryFactory from '@/repository/RepositoryFactory';
import {
  PostShiftPatternsRequest,
  PutShiftPatternsRequest,
  ResponseAbsenceTimeFrame,
  ResponseWorkingTimeFrame,
} from '@/model/repository';

const shiftServiceRepositories = RepositoryFactory.shiftService;

/**
 * シフトパターンを取得
 */
export async function fetchShiftPatterns(idGenerator: () => string) {
  const response = await shiftServiceRepositories.shiftPatterns.index();
  const result = response.data;
  // 枠を識別するためにuuidを付与する
  const mapTimeFrames = (timeFrame: ResponseAbsenceTimeFrame | ResponseWorkingTimeFrame) => {
    return {
      ...timeFrame,
      uuid: idGenerator(),
    };
  };
  return result.map((shiftPattern) => ({
    ...shiftPattern,
    workingTimeFrames: shiftPattern.workingTimeFrames.map(mapTimeFrames),
    absenceTimeFrames: shiftPattern.absenceTimeFrames.map(mapTimeFrames),
  }));
}

/**
 * シフトパターンを更新
 */
export async function updateShiftPatterns(id: string, payload: PutShiftPatternsRequest) {
  const response = await shiftServiceRepositories.shiftPatterns.update(id, payload);
  return response;
}

/**
 * シフトパターンを作成
 */
export async function storeShiftPatterns(payload: PostShiftPatternsRequest) {
  const response = await shiftServiceRepositories.shiftPatterns.create(payload);
  return response;
}
